import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69c919d7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal is-active"
}
const _hoisted_2 = { class: "modal-card" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "modal-card-head" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "modal-card-title" }, "Дубли по ИНН")
], -1))
const _hoisted_4 = { class: "modal-card-body with-scrollbar" }
const _hoisted_5 = { class: "is-size-5" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("footer", { class: "modal-card-foot" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.model !== null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "modal-background",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }),
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("section", _hoisted_4, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.doubles, (double, key) => {
                return (_openBlock(), _createElementBlock("li", _hoisted_5, [
                  _createTextVNode(_toDisplayString(key+1) + ". " + _toDisplayString(), 1),
                  _createVNode(_component_router_link, {
                    to: { name: 'AgentsCard', params: { agent: double.agent_id } }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(double.fullname), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              }), 256))
            ])
          ]),
          _hoisted_6,
          _createElementVNode("button", {
            class: "modal-close is-large",
            "aria-label": "close",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          })
        ])
      ]))
    : _createCommentVNode("", true)
}